import { Box, SxProps, Theme, Typography } from '@mui/material';
import Center from './Center';
import React from 'react';
import styled from '@emotion/styled';
import { spacing } from '@mui/system';
import CircularProgress from '@mui/material/CircularProgress';
import { BoxProps } from '@mui/material/Box';
import { Info } from '@mui/icons-material';

export interface EmptyResultsProps extends BoxProps {
  icon?: React.ReactNode;
  showDefaultIcon?: boolean;
  headerText?: string | null;
  text?: string | null;
  hasRows?: boolean;
  isLoading?: boolean;
  loadingText?: string;
  useTablePresets?: boolean;
  sx?: SxProps<Theme>;
}

const EmptyResultsBase: React.FC<EmptyResultsProps> = ({
  icon,
  showDefaultIcon = true,
  headerText,
  text,
  hasRows,
  isLoading,
  loadingText,
  useTablePresets,
  sx,
  ...rest
}) => {
  let sxProps: SxProps<Theme> = { ...sx };
  if (useTablePresets) {
    sxProps = { ...sxProps, ...{ borderBottom: '1px solid', borderColor: (theme: Theme) => theme.palette.divider, p: 4 } };
  }
  return (
    (!hasRows || isLoading) && (
      <Box width="100%" sx={sxProps} {...rest}>
        <Box py={15} border="1px solid" borderColor={(theme) => theme.palette.divider}>
          <Center>
            {isLoading && (
              <CircularProgress
                size={30}
                sx={{
                  color: (theme) => theme.palette.secondary.main,
                }}
              />
            )}
            {!isLoading && (icon ?? (showDefaultIcon && <Info color="action" fontSize="large" />))}
            {!isLoading && (
              <Typography mt={3} px={5} sx={{ color: (theme) => theme.palette.action.active, textAlign: 'center' }} variant="h4">
                {!isLoading && (headerText ?? 'No results found')}
              </Typography>
            )}
            <Typography mt={3} px={5} sx={{ color: (theme) => theme.palette.action.active, textAlign: 'center' }} variant="subtitle1">
              {!isLoading && (text ?? 'Adjust your selections and try again')}
              {isLoading && (loadingText || 'Retrieving results...')}
            </Typography>
          </Center>
        </Box>
      </Box>
    )
  );
};

const EmptyResults = styled(EmptyResultsBase)(spacing);

export default EmptyResults;
